import { I as t } from "../../constants-DeVuDy8J.js";
import { openBlock as n, createElementBlock as d, normalizeClass as o, createElementVNode as i } from "vue";
import { _ as s } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const c = {
  name: "DtIconSmartphoneCharging",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(t).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return t[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, u = ["aria-label", "data-qa", "aria-hidden"];
function m(e, r, l, h, p, a) {
  return n(), d("svg", {
    "aria-label": l.ariaLabel,
    class: o([a.iconSizeClass, "d-icon d-icon--smartphone-charging"]),
    "data-qa": a.dataQA,
    "aria-hidden": a.ariaHidden,
    role: "img",
    "data-name": "Smartphone Charging",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12"
  }, [...r[0] || (r[0] = [
    i("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M3.5 1.5A.5.5 0 0 0 3 2v8a.5.5 0 0 0 .5.5h5A.5.5 0 0 0 9 10V2a.5.5 0 0 0-.5-.5h-5ZM2 2A1.5 1.5 0 0 1 3.5.5h5A1.5 1.5 0 0 1 10 2v8a1.5 1.5 0 0 1-1.5 1.5h-5A1.5 1.5 0 0 1 2 10V2Z",
      "clip-rule": "evenodd"
    }, null, -1),
    i("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M6.61 3.584a.5.5 0 0 1 .14.693L5.934 5.5H7a.5.5 0 0 1 .416.777l-1.333 2a.5.5 0 0 1-.833-.554L6.066 6.5H5a.5.5 0 0 1-.416-.777l1.333-2a.5.5 0 0 1 .694-.139Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])], 10, u);
}
const v = /* @__PURE__ */ s(c, [["render", m]]);
export {
  v as default
};
//# sourceMappingURL=smartphone-charging.js.map
